import { useQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: convex _generated
import type { Id } from '../../../convex/_generated/dataModel'; // DEEP_IMPORT_JUSTIFIED: convex _generated
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { Building2, User } from 'lucide-react';

interface IUserHierarchyTreeProps {
  orgId: Id<'organisations'>;
} // LOCAL_TYPE_JUSTIFIED: component props interface

export function UserHierarchyTree({ orgId }: IUserHierarchyTreeProps) {
  const hierarchy = useQuery(api.superadmin.queries.getUserHierarchy, { orgId });
  if (hierarchy === undefined) {
    return (
      <div className="pl-8 py-2 space-y-2">
        <Skeleton className="h-4 w-48" />
        <Skeleton className="h-4 w-36" />
        <Skeleton className="h-4 w-40" />
      </div>
    );
  }
  return (
    <div className="pl-8 py-3 bg-muted/30 border-t border-border">
      <div className="text-xs font-medium text-muted-foreground mb-2">
        Owner: {hierarchy.owner.name ?? hierarchy.owner.email ?? 'Unknown'}
      </div>
      {hierarchy.companies.length === 0 ? (
        <p className="text-xs text-muted-foreground">No companies</p>
      ) : (
        <div className="space-y-3">
          {hierarchy.companies.map(company => (
            <div key={company._id} className="space-y-1">
              <div className="flex items-center gap-2 text-sm">
                <Building2 className="w-3.5 h-3.5 text-muted-foreground" />
                <span className="font-medium">{company.name}</span>
                <Badge variant="outline" className="text-xs">
                  {company.status}
                </Badge>
                <span className="text-xs text-muted-foreground">
                  {company.employeeCount} employees
                </span>
              </div>
              {company.members.map(member => (
                <div
                  key={member.userId}
                  className="flex items-center gap-2 text-xs text-muted-foreground pl-6"
                >
                  <User className="w-3 h-3" />
                  <span>{member.name ?? member.email ?? 'Unknown'}</span>
                  {member.roles.map(role => (
                    <Badge key={role} variant="secondary" className="text-[10px] px-1 py-0">
                      {role}
                    </Badge>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
